import { AuthSession, LoginCredentials, UserAccount } from '../../types';
import { apiClient } from '../client';

export async function login(credentials: LoginCredentials): Promise<AuthSession> {
  const { data } = await apiClient.post<AuthSession>('/auth/login', credentials);
  return data;
}

/** Reads the httpOnly `fishoil_refresh_token` cookie server-side — no body needed. Also rotates the cookie. */
export async function refresh(): Promise<AuthSession> {
  const { data } = await apiClient.post<AuthSession>('/auth/refresh');
  return data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function me(): Promise<UserAccount> {
  const { data } = await apiClient.get<UserAccount>('/auth/me');
  return data;
}
